import React from "react";
import TspStoryListPage from "./TspStoryListPage";

// Success Stories (/tsp/success-stories): inspiring incidents, miracles and
// personal experiences from the road. Shares its screen with Blogs.
export default function TspStoriesPage() {
  return <TspStoryListPage kind="success" />;
}
